import { request } from './client';

export const apiGetBanners = (type) =>
  request(`/banners${type ? `?type=${type}` : ''}`);
